import React from 'react';

const sum = (rows, key) => rows.reduce((acc, row) => acc + (Number(row?.[key]) || 0), 0);
const fmt = (value) => Number(value || 0).toLocaleString('ko-KR');

export default function ReservationFormSummary({ flights, cars, hotels, payments }) {
  const flightTotal = sum(flights, 'total_payment');
  const carTotal = sum(cars, 'total_cost');
  const hotelTotal = sum(hotels, 'total_cost');
  const paidTotal = sum(payments, 'amount');
  const costTotal = flightTotal + carTotal + hotelTotal;
  const difference = paidTotal - costTotal;

  return (
    <div style={summaryBar}>
      <SummaryItem label="총 지불액" value={paidTotal} strong />
      <SummaryItem label="항공" value={flightTotal} />
      <SummaryItem label="렌트" value={carTotal} />
      <SummaryItem label="호텔" value={hotelTotal} />
      <SummaryItem label="차액" value={difference} danger={difference < 0} strong />
    </div>
  );
}

function SummaryItem({ label, value, danger, strong }) {
  return (
    <div style={summaryItem}>
      <span style={summaryLabel}>{label}</span>
      <span style={{ ...summaryValue, fontWeight: strong ? 800 : 700, color: danger ? '#dc2626' : 'var(--text)' }}>{fmt(value)}</span>
    </div>
  );
}

const summaryBar = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(140px, 100%), 1fr))', gap: 8, background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 8, padding: 8, minWidth: 0, boxSizing: 'border-box' };
const summaryItem = { display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 8, padding: '6px 8px', background: 'var(--bg)', borderRadius: 6 };
const summaryLabel = { fontSize: 11, color: 'var(--text-muted)', whiteSpace: 'nowrap' };
const summaryValue = { fontSize: 14, textAlign: 'right', whiteSpace: 'nowrap' };
